import React from 'react';

export const SuccessInfoComponent = ({ children }) => (
    <div className="info form-success-message mtm">{children}</div>
);



// WEBPACK FOOTER //
// ./src/components/form/SuccessInfoComponent.js